import { Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import FormatTypesFilterCard from "./FormatTypesFilter/FormatTypesFilterCard";
import { FormatTypesTable } from "./FormatTypesTable/FormatTypesTable";
import Page404 from "../../../Page404/Page403";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  selectUserData,
  selectUserToken,
  setIsLoading,
} from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

const FormatTypes = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewFormatTypePermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_format_types"
  );

  useEffect(() => {
    const fetchMetaEntitiesFormatTypes = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaFormatTypes(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesFormatTypes();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewFormatTypePermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Format Types List</Typography>
            <FormatTypesFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <FormatTypesTable />
          </Paper>
        </>
      )}
    </>
  );
};

export default FormatTypes;
